/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from 'react';
import { SortingState } from '@tanstack/react-table';
import { tableStrings } from '../i18n/de-de';
import { BmweDataColumn } from '../../../types';

export function useSortAnnouncement<TRow extends Record<string, unknown>>(
  sorting: SortingState,
  columns: BmweDataColumn<TRow>[],
  clearDelayMs = 1000,
): string {
  const [announcement, setAnnouncement] = useState('');
  useEffect(() => {
    if (sorting.length) {
      const first = sorting[0];
      const col = columns.find((c) => (c.field || c.id) === first.id);
      const direction = first.desc
        ? tableStrings.descending
        : tableStrings.ascending;
      const name = col?.header || first.id;
      setAnnouncement(tableStrings.messages.tableSortedBy(direction, name));
    } else {
      setAnnouncement(tableStrings.messages.tableSortCleared);
    }
    const timeout = setTimeout(() => setAnnouncement(''), clearDelayMs);
    return () => clearTimeout(timeout);
  }, [sorting, columns, clearDelayMs]);
  return announcement;
}
